import { trackDecisionTreeTextCopied, SEARCH_ACTION_SOURCES } from '../../../../analytics/searchEventAnalytics';
import { parseSanitizedHtml } from '../../../../util';
import React from 'react';
import { useSelector } from 'react-redux';
import { getTemplatedCopyTextFromCurrentDecisionNode } from '../../../../selectors/templating';
import { MacroContent, TitleText, MacroHeader, MacroText } from './DTMacroText.styles';

export const DTMacroText = (props) => {
  const { onFreeCopy, disableManualCopy = false } = props;

  const templatedCopyText = useSelector(getTemplatedCopyTextFromCurrentDecisionNode);

  const handleFreeCopy = () => {
    if (onFreeCopy) {
      onFreeCopy();
    }
    trackDecisionTreeTextCopied(SEARCH_ACTION_SOURCES.FREE_COPY);
  };

  return (
    <MacroContent>
      <MacroHeader>
        <TitleText>This is the response that will be copied into your reply box:</TitleText>
      </MacroHeader>
      <MacroText
        disableManualCopy={disableManualCopy}
        onCopy={handleFreeCopy}
        {...parseSanitizedHtml(templatedCopyText)}
      />
    </MacroContent>
  );
};
